import React from 'react';
import { Text, TextMessage } from 'components/tt-forms/common';
import moment from 'moment';
import { ShowIf } from 'components/utils';

class DonDocDoiTuongView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      //bool
      dataDetail: this.props.dataDetail,
      getThoiHanDonDoc: false,
      enableDelete: this.props.enableDelete,

      coQuanBanHanhCuongChe: this.props.coQuanBanHanhCuongChe ? this.props.coQuanBanHanhCuongChe : '',
      coQuanBanHanhHuyCuongChe: this.props.coQuanBanHanhHuyCuongChe ? this.props.coQuanBanHanhHuyCuongChe : '',
      doiTuongViPham: this.props.doiTuongViPham ? this.props.doiTuongViPham : '',
      ghiChu: this.props.ghiChu ? this.props.ghiChu : '',
      hinhThucCuongChe: this.props.hinhThucCuongChe ? this.props.hinhThucCuongChe : '',
      hinhThucDonDoc: this.props.hinhThucDonDocInfo ? this.props.hinhThucDonDocInfo.text : '',
      huyCuongChe: this.props.huyCuongChe ? this.props.huyCuongChe : false,
      id: this.props.donDocDoiTuongId ? this.props.donDocDoiTuongId : '',
      ketQuaThucHien: this.props.ketQuaThucHienInfo ? this.props.ketQuaThucHienInfo.text : '',
      ngayBanHanh: this.props.ngayBanHanh ? moment(this.props.ngayBanHanh).format('DD/MM/YYYY') : '',
      ngayBanHanhCuongChe: this.props.ngayBanHanhCuongChe ? moment(this.props.ngayBanHanhCuongChe).format('DD/MM/YYYY') : '',
      ngayBanHanhHuyCuongChe: this.props.ngayBanHanhHuyCuongChe ? moment(this.props.ngayBanHanhHuyCuongChe).format('DD/MM/YYYY') : '',
      ngayBatDauDonDoc: this.props.ngayBatDauDonDoc ? moment(this.props.ngayBatDauDonDoc).format('DD/MM/YYYY') : '',
      ngayHetHanDonDoc: this.props.ngayHetHanDonDoc ? moment(this.props.ngayHetHanDonDoc).format('DD/MM/YYYY') : '',
      ngayHetHanDonDocISO: this.props.ngayHetHanDonDoc ? this.props.ngayHetHanDonDoc : '',
      soQuyetDinhCuongChe: this.props.soQuyetDinhCuongChe ? this.props.soQuyetDinhCuongChe : '',
      soQuyetDinhHuyCuongChe: this.props.soQuyetDinhHuyCuongChe ? this.props.soQuyetDinhHuyCuongChe : '',
      soTienCuongChe: this.props.soTienCuongChe ? this.props.soTienCuongChe : '',
      soVanBan: this.props.soVanBan ? this.props.soVanBan : '',
      thoiGianThucHienCuongChe: this.props.thoiGianThucHienCuongChe ? moment(this.props.thoiGianThucHienCuongChe).format('DD/MM/YYYY') : '',
      thoiGianThucHienHuyCuongChe: this.props.thoiGianThucHienHuyCuongChe ? moment(this.props.thoiGianThucHienHuyCuongChe).format('DD/MM/YYYY') : '',
      thoiHanDonDoc: this.props.thoiHanDonDoc ? this.props.thoiHanDonDoc : 0,
      thoiHanNgayLamViecDonDoc: this.props.thoiHanNgayLamViecDonDoc ? this.props.thoiHanNgayLamViecDonDoc : '',
      tinhHinhTienDoThucHienCuongChe: this.props.tinhHinhTienDoThucHienCuongChe ? this.props.tinhHinhTienDoThucHienCuongChe : '',
      tinhHinhTienDoThucHienKetLuan: this.props.tinhHinhTienDoThucHienKetLuan ? this.props.tinhHinhTienDoThucHienKetLuan : '',
      toChucTinDungThucHienCuongChe: this.props.toChucTinDungThucHienCuongChe ? this.props.toChucTinDungThucHienCuongChe : '',
      toChucTinDungThucHienHuyCuongChe: this.props.toChucTinDungThucHienHuyCuongChe ? this.props.toChucTinDungThucHienHuyCuongChe : '',

      dataKetQuaThucHienDonDoc: this.props.dataKetQuaThucHienDonDoc,
      dataHinhThucDonDoc: this.props.dataHinhThucDonDoc
    }
  }

  render() {
    return (
      <div>
        <ShowIf condition={this.props.countItem <= 1}>
          <div className='justify-content mb15'>
            <h2 className='title-12 mt15'>{`${this.props.toChucLienQuan ? '2' : '3'}.1. Đôn đốc`}</h2>
          </div>
        </ShowIf>
        <ShowIf condition={this.props.countItem > 1}>
          <ShowIf condition={this.props.index > 0}>
            <div className='line-border'></div>
          </ShowIf>
          <div className={`mt15 justify-content mb15`}>
            <h2 className='title-12'>{`${this.props.toChucLienQuan ? '2' : '3'}.${this.props.index + 1}. Lần đôn đốc số ${this.props.index + 1}`}</h2>
          </div>
        </ShowIf>
        <div className='row pl10 pr10'>
          <Text className='col-25 mb10' label='Hình thức đôn đốc:' value={this.state.hinhThucDonDoc}/>
          <Text className='col-25 mb10' label='Số văn bản:' value={this.state.soVanBan}/>
          <Text className='col-25 mb10' label='Ngày ban hành:' value={this.state.ngayBanHanh}/>
        </div>

        <div className='row pl10 pr10'>
          <Text className='col-25 mb10' label='Ngày bắt đầu:' value={this.state.ngayBatDauDonDoc}/>
          <Text className='col-25 mb10' label='Thời hạn đôn đốc (ngày làm việc):' value={`${this.state.thoiHanDonDoc} ngày (${this.state.ngayHetHanDonDoc})`}/>
          <TextMessage className='col-100 mb10' label='Tình hình, tiến độ thực hiện kết luận:' value={this.state.tinhHinhTienDoThucHienKetLuan}/>
          <Text className='col-25 mb10' label='Kết quả đôn đốc:' value={this.state.ketQuaThucHien}/>
        </div>

        <ShowIf condition={this.props.ketQuaThucHien == 'CHUA_THUC_HIEN'}>
          <div className='row pl10 pr10'>
            <h2 className='col-100 txt-bold txt-upper mb15 text-14 mt5'>Cưỡng chế</h2>
            <Text className='col-25 mb10' label='Số quyết định cưỡng chế:' value={this.state.soQuyetDinhCuongChe}/>
            <Text className='col-25 mb10' label='Ngày ban hành:' value={this.state.ngayBanHanhCuongChe}/>
            <Text className='col-25 mb10' label='Cơ quan ban hành:' value={this.state.coQuanBanHanhCuongChe}/>
            <Text className='col-25 mb10' label='Số tiền (đ):' value={this.state.soTienCuongChe}/>
          </div>
          <div className='row pl10 pr10'>
            <Text className='col-25 mb10' label='Thời gian thực hiện:' value={this.state.thoiGianThucHienCuongChe}/>
            <Text className='col-25 mb10' label='Tổ chức tín dụng thực hiện:' value={this.state.toChucTinDungThucHienCuongChe}/>
            <Text className='col-25 mb10' label='Tình hình tiến độ thực hiện:' value={this.state.tinhHinhTienDoThucHienCuongChe}/>
            <Text className='col-25 mb10' label='Hình thức cưỡng chế:' value={this.state.hinhThucCuongChe}/>
          </div>

          <div className='row pl15 pr15'>
            <ShowIf condition={this.state.huyCuongChe}>
              <div className='row pl10 pr10'>
                <h2 className='col-100 txt-bold txt-upper mb15 text-14 mt5'>Hủy cưỡng chế</h2>
                <Text className='col-25 mb10' label='Số quyết định hủy cưỡng chế:' value={this.state.soQuyetDinhHuyCuongChe}/>
                <Text className='col-25 mb10' label='Ngày ban hành:' value={this.state.ngayBanHanhHuyCuongChe}/>
                <Text className='col-25 mb10' label='Cơ quan ban hành:' value={this.state.coQuanBanHanhHuyCuongChe}/>
                <TextMessage className='col-100 mb10' label='Ghi chú:' value={this.state.ghiChu}/>
              </div>
              <div className='row pl10 pr10'>
                <Text className='col-25 mb10' label='Thời gian thực hiện:' value={this.state.thoiGianThucHienHuyCuongChe}/>
                <Text className='col-25 mb10' label='Tổ chức tín dụng thực hiện:' value={this.state.toChucTinDungThucHienHuyCuongChe}/>
              </div>
              <div className='row pl10 pr10'>
                <TextMessage className='col-100 mb10' label='Ghi chú:' value={this.state.ghiChu}/>
              </div>
            </ShowIf>
          </div>
        </ShowIf>
      </div>
    )
  }
}

DonDocDoiTuongView.defaultProps = {
  validators: {
    formTaoDon: []
  },
  enableDelete: false,
  dataDetail: []
}

export default DonDocDoiTuongView;



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/DonDocDoiTuongView.jsx